import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { FileUtils } from '@shared/utils';
import { AccountsApi, type DownloadDocumentRequest, type WithSignal } from '@shared/api';

const downloadDocumentEffect = createEffect(({ signal, ...request }: WithSignal<DownloadDocumentRequest>) =>
  AccountsApi.downloadDocument(request, signal),
);
const clearEvent = createEvent();

const $loadingStore = createStore<boolean>(false)
  .on(downloadDocumentEffect.pending, (_, data) => data)
  .on(downloadDocumentEffect.fail, () => false)
  .on(downloadDocumentEffect.done, () => false)
  .reset(clearEvent);

downloadDocumentEffect.done.watch((result) => FileUtils.downloadFile(result.result));
downloadDocumentEffect.fail.watch(() => $notificationStore.events.setError('Something went wrong while downloading Document. Please try again.'));

export const $downloadAccountDocumentStore = {
  events: {
    downloadDocument: downloadDocumentEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
  }),
};
